import { LitElement, html, css } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import type { NotificationBellAttributes } from 'zaptic-notification-bell'
import { booleanAttributeSchema, positiveIntegerAttributeSchema } from './helpers/yup'
import { onAttributeChange } from './helpers/onAttributeChange'

@customElement('zaptic-notification-bell')
export class NotificationBell extends LitElement implements NotificationBellAttributes {
    static styles = css`
        :host {
            display: inline-block;
        }

        #bell {
            display: flex;
            align-items: start;
            color: var(--NotificationBell-passiveColor);
        }

        #bell.active {
            color: var(--NotificationBell-activeColor);
        }

        zaptic-icon {
            display: block;
            width: var(--NotificationBell-bellSize);
            aspect-ratio: 1/1;
        }

        zaptic-labelled-circle {
            --LabelledCircle-textColor: white;
            --LabelledCircle-backgroundColor: var(--NotificationBell-passiveColor);
            --LabelledCircle-size: calc(0.4 * var(--NotificationBell-bellSize));

            display: none;
            margin-left: calc(-0.4 * var(--NotificationBell-bellSize));
        }

        :host([count]) zaptic-labelled-circle {
            --LabelledCircle-backgroundColor: var(--NotificationBell-activeColor);

            display: block;
        }

        :host([count='0']) zaptic-labelled-circle {
            display: none;
        }
    `

    @property({ type: Number })
    count = 0

    @property({ type: Boolean })
    active = false

    attributeChangedCallback(name: string, old: string, value: string): void {
        super.attributeChangedCallback(name, old, value)
        onAttributeChange(this, name, old, value, () => {
            switch (name) {
                case 'count':
                    this.count = positiveIntegerAttributeSchema.validateSync(value)
                    return
                case 'active':
                    this.active = booleanAttributeSchema.validateSync(value)
                    return
            }
        })
    }

    render() {
        const count = displayCount(this.count)
        return html`
            <div id="bell" class="${this.active ? 'active' : ''}">
                <zaptic-icon icon-name="notification-bell"></zaptic-icon>
                <zaptic-labelled-circle label="${count}"></zaptic-labelled-circle>
            </div>
        `
    }
}

function displayCount(count: number) {
    if (!count) return ''
    if (count > 99) return '99+'
    return count.toString()
}
